import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    container: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        marginTop: 64,
    },
    form: {
        marginTop: 8,
        width: "100%",
    },
    submit_button: {
        margin: "24px 0 16px",
    },
    sign_in_error: {
        color: theme.palette.secondary.main,
        textAlign: "center",
        marginTop: theme.spacing(2),
    },
}))
